import * as React from 'react'

import { OptionsParsedQuery, parseOptionsQuery } from '../utils/query'

export function useOptionsQuery(params: URLSearchParams): OptionsParsedQuery {
  return React.useMemo(() => parseOptionsQuery(params), [params])
}
